import { useTranslation } from '../../hooks/useTranslation';
import { encUrl } from '../../utils/encUrl';
import EncryptedImage from '../../components/EncryptedImage/EncryptedImage';
import styles from './About.module.css';

const About = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.about}>
      <div className={styles.content}>
        <div className={styles.imageSection}>
          <EncryptedImage
            src={encUrl('/images-optimized/profile/profile-4.jpg')}
            alt="Antoine Pierson"
            className={styles.profileImage}
          />
        </div>

        <div className={styles.textSection}>
          <h1 className={styles.title}>{t('about.title')}</h1>

          <div className={styles.bio}>
            <p>
              {t('about.bio.intro')}
            </p>

            <p>
              {t('about.bio.paragraph1')}
            </p>

            <p>
              {t('about.bio.paragraph2')}
            </p>

            <p>
              {t('about.bio.paragraph3')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
